import React from 'react';
import { IconProps } from '.';

const SvgNew = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='M2 22h5.489V9.53h.137L15.86 22H22V2h-5.489v11.19h-.103L8.964 2H2v20Z' />
    </svg>
  );
};

export default SvgNew;
